import { ReasonType } from "@rooster/types";
import { v4 } from "uuid";
import { logRocketSessionUrl } from "../../utils/logRocket";
import { baseUrlServer } from "./common";
import { axiosWithRetry } from "./utils/axiosRetry";

export const cancelAutobook = async ({
  availabilityId,
  reason,
  comment
}: {
  availabilityId: string;
  reason?: ReasonType;
  comment?: string;
}) => {
  const url = `${baseUrlServer}/multiDayAutobook/candidate/cancel`;
  try {
    const reasonPayload = reason
      ? { ...reason, comment }
      : {
          type: "cancel",
          audience: "candidate",
          scheduledEventType: "candidateApp",
          comment
        };

    const response = await axiosWithRetry(url, "post", {
      data: {
        data: {
          id: availabilityId,
          reason: reasonPayload
        },
        config: {
          uuid: v4(),
          sessionUrl: logRocketSessionUrl ?? "",
          requestTimestamp: Date.now(),
          method: "autobook"
        }
      },
      timeout: 120000
    });

    return response.data as string;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error(error?.message);
    }
    return undefined;
  }
};
